import { render, staticRenderFns } from "./TestQuestionControls.vue?vue&type=template&id=a430a274&scoped=true&"
import script from "./TestQuestionControls.vue?vue&type=script&lang=js&"
export * from "./TestQuestionControls.vue?vue&type=script&lang=js&"
import style0 from "./TestQuestionControls.vue?vue&type=style&index=0&id=a430a274&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a430a274",
  null
  
)

export default component.exports